import { initCalendar } from '../common/calendar';
import { initSearchBarFields, initSearchOptionClick, initSearchDropdownHandler } from '../common/searchBarFields';
import { SearchRoomManager } from '../common/searchRoomManager';
import { initSubscribeEmailForm } from "../common/subscribeEmailForm";

document.addEventListener('DOMContentLoaded', () => {
    // the various search bar field elements - used to determine what needs loading
    const calendarEl = document.querySelector('#calendar');
    if (calendarEl) {
        initCalendar(false);
    }

    const locationEl = document.querySelector('#location');
    if (locationEl) {
        // Initialize the search bar fields and sheets/dropdowns
        initSearchBarFields({ desktopBreakpoint: 992 });
        initSearchDropdownHandler();

        // Initialize search-option click handling
        initSearchOptionClick();
    }

    const roomsEl = document.querySelector('#rooms');
    if (roomsEl) {
        // Example max rooms
        const maxRooms = 5;

        // Create instance
        const searchRoomManager = new SearchRoomManager(maxRooms);

        // Initialise event handlers
        searchRoomManager.init();
    }
    
    initSubscribeEmailForm();
});